import { createFileRoute } from "@tanstack/react-router";

import { TruckContent } from "@/features/dashboard/caminhoes/components/TruckContent";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes/marcas/editar/$id/")({
  component: TruckContent
});
